import React, { useState } from 'react';
import { BoldIcon, ItalicIcon, UnderlineIcon, StrikethroughIcon, LinkIcon, CodeIcon, QuoteIcon, ListIcon, ListOrderedIcon, AlignLeftIcon, PencilIcon, TrashIcon, PlusIcon } from 'lucide-react';
type Section = 'departements' | 'categories' | 'statuts' | 'messages';
interface Departement {
  id: string;
  nom: string;
  responsable: string;
}
interface Categorie {
  id: string;
  nom: string;
  departementId: string;
  sla: number;
}
interface Statut {
  id: string;
  nom: string;
  couleur: string;
}
interface MessageTpl {
  id: string;
  titre: string;
  contenu: string;
}
const MOCK_DEPARTEMENTS: Departement[] = [{
  id: '1',
  nom: 'Service Des Travaux Publics',
  responsable: 'Jean Dupont'
}, {
  id: '2',
  nom: 'Urbanisme',
  responsable: 'Marie Tremblay'
}];
const MOCK_CATEGORIES: Categorie[] = [{
  id: '1',
  nom: 'Voirie et infrastructures routières',
  departementId: '1',
  sla: 14
}, {
  id: '2',
  nom: 'Parcs et espaces récréatifs',
  departementId: '1',
  sla: 7
}, {
  id: '3',
  nom: 'Bâtiment',
  departementId: '2',
  sla: 30
}];
const MOCK_STATUTS: Statut[] = [{
  id: '1',
  nom: 'Nouvelle demande',
  couleur: 'bg-slate-200'
}, {
  id: '2',
  nom: 'En Cours',
  couleur: 'bg-[#4F46E5]'
}, {
  id: '3',
  nom: 'Complété',
  couleur: 'bg-[#4F46E5]'
}];
const MOCK_MESSAGES: MessageTpl[] = [{
  id: '1',
  titre: 'Confirmation de réception',
  contenu: 'Votre requête a bien été reçue et sera traitée dans les plus brefs délais.'
}, {
  id: '2',
  titre: 'Requête complétée',
  contenu: 'Nous vous informons que les travaux liés à votre requête sont maintenant terminés.'
}];
export function RequetesConfigurer() {
  const [activeSection, setActiveSection] = useState<Section>('departements');
  const [departements, setDepartements] = useState<Departement[]>(MOCK_DEPARTEMENTS);
  const [categories, setCategories] = useState<Categorie[]>(MOCK_CATEGORIES);
  const [statuts, setStatuts] = useState<Statut[]>(MOCK_STATUTS);
  const [messages, setMessages] = useState<MessageTpl[]>(MOCK_MESSAGES);
  const renderToolbar = () => <div className="flex items-center gap-1 p-2 bg-slate-50 border border-slate-200 rounded-t-lg flex-wrap" data-id="element-5162" data-mp="ur5qub058hqi">
      <select className="text-xs border border-slate-300 rounded px-2 py-1 bg-white" data-id="element-5163" data-mp="kzj6np5tv8bm">
        <option data-id="element-5164" data-mp="kx6obaw5qvy1">Sans Serif</option>
      </select>
      <select className="text-xs border border-slate-300 rounded px-2 py-1 bg-white ml-2" data-id="element-5165" data-mp="g1hl8xkxiwwz">
        <option data-id="element-5166" data-mp="1dogjvdv6mexi">Normal</option>
      </select>
      <div className="flex items-center gap-1 ml-2 border-l border-slate-300 pl-2" data-id="element-5167" data-mp="1dm467cwgiqq9">
        <button className="p-1 hover:bg-slate-200 rounded" title="H1" data-id="element-5168" data-mp="18pwzhhw8lb79">
          <span className="text-xs font-bold" data-id="element-5169" data-mp="13ozj9auser8e">H₁</span>
        </button>
        <button className="p-1 hover:bg-slate-200 rounded" title="H2" data-id="element-5170" data-mp="zopc3uv9dury">
          <span className="text-xs font-bold" data-id="element-5171" data-mp="zqidaun3rmsk">H₂</span>
        </button>
      </div>
      <div className="flex items-center gap-1 ml-2 border-l border-slate-300 pl-2" data-id="element-5172" data-mp="3ohkv99zikxoh">
        <button className="p-1 hover:bg-slate-200 rounded" data-id="element-5173" data-mp="3kdvakvlyn08q">
          <BoldIcon className="w-4 h-4" data-id="element-5174" data-mp="1zwvq4of1zrra" />
        </button>
        <button className="p-1 hover:bg-slate-200 rounded" data-id="element-5175" data-mp="1zyglgg96zeq7">
          <ItalicIcon className="w-4 h-4" data-id="element-5176" data-mp="23z8ylkl6q3rr" />
        </button>
        <button className="p-1 hover:bg-slate-200 rounded" data-id="element-5177" data-mp="28xaha4ep812p">
          <UnderlineIcon className="w-4 h-4" data-id="element-5178" data-mp="28vr10dt1lq0x" />
        </button>
        <button className="p-1 hover:bg-slate-200 rounded" data-id="element-5179" data-mp="2dok6j3wc52e2">
          <StrikethroughIcon className="w-4 h-4" data-id="element-5180" data-mp="2dq3i4h71qp9i" />
        </button>
      </div>
      <div className="flex items-center gap-1 ml-2 border-l border-slate-300 pl-2" data-id="element-5181" data-mp="2imlpzpxob3q2">
        <button className="p-1 hover:bg-slate-200 rounded" data-id="element-5182" data-mp="2nkvh9pga1k6e">
          <LinkIcon className="w-4 h-4" data-id="element-5183" data-mp="2ro1oazb7rfdx" />
        </button>
        <button className="p-1 hover:bg-slate-200 rounded" data-id="element-5184" data-mp="2rol3475khnnq">
          <CodeIcon className="w-4 h-4" data-id="element-5185" data-mp="2wn4tqkv3vnmf" />
        </button>
        <button className="p-1 hover:bg-slate-200 rounded" data-id="element-5186" data-mp="2wkil0hwhb22m">
          <QuoteIcon className="w-4 h-4" data-id="element-5187" data-mp="xb29h8enqp7p" />
        </button>
      </div>
      <div className="flex items-center gap-1 ml-2 border-l border-slate-300 pl-2" data-id="element-5188" data-mp="128c0utllxay6">
        <button className="p-1 hover:bg-slate-200 rounded" data-id="element-5189" data-mp="6yf6s6ldhbyt">
          <span className="text-xs font-bold" data-id="element-5190" data-mp="6wucmi2yzv1h">A</span>
        </button>
      </div>
      <div className="flex items-center gap-1 ml-2 border-l border-slate-300 pl-2" data-id="element-5191" data-mp="1ysubzddbzr2">
        <button className="p-1 hover:bg-slate-200 rounded" data-id="element-5192" data-mp="gvtmg3zh1wq2">
          <ListIcon className="w-4 h-4" data-id="element-5193" data-mp="bxs11cekplbf" />
        </button>
        <button className="p-1 hover:bg-slate-200 rounded" data-id="element-5194" data-mp="byb8u0aietbq">
          <ListOrderedIcon className="w-4 h-4" data-id="element-5195" data-mp="3kd1xo4zp1ybt" />
        </button>
      </div>
      <div className="flex items-center gap-1 ml-2 border-l border-slate-300 pl-2" data-id="element-5196" data-mp="3feif8ekb74o7">
        <button className="p-1 hover:bg-slate-200 rounded" data-id="element-5197" data-mp="3fcnqep5x2seu">
          <AlignLeftIcon className="w-4 h-4" data-id="element-5198" data-mp="3u46gjfshq3bx" />
        </button>
      </div>
    </div>;
  const renderDepartements = () => <div className="space-y-4" data-id="element-5199" data-mp="3pb3gcot7jvmr">
      <div className="flex items-center justify-between" data-id="element-5200" data-mp="31n3ua26uctei">
        <h3 className="text-lg font-bold text-[#0F172A]" data-id="element-5201" data-mp="31lixs70yv0e0">Départements</h3>
        <button className="px-4 py-2 text-sm font-medium text-[#4F46E5] border border-[#4F46E5] rounded-lg hover:bg-[#4F46E5] hover:text-white transition-colors flex items-center gap-2" data-id="element-5202" data-mp="2wosgxhhc80rj">
          <PlusIcon className="w-4 h-4" data-id="element-5203" data-mp="1gx6ubimdpxvu" /> Ajouter un département
        </button>
      </div>
      <div className="bg-white rounded-lg border border-slate-200 overflow-hidden" data-id="element-5204" data-mp="128an1ns5cowa">
        <table className="w-full" data-id="element-5205" data-mp="176veaxpf7y8l">
          <thead className="bg-slate-50 border-b border-slate-200" data-id="element-5206" data-mp="177x0nybw075m">
            <tr data-id="element-5207" data-mp="1uwpo16eg16om">
              <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wide" data-id="element-5208" data-mp="1uw6g8iiibyob">
                Nom
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wide" data-id="element-5209" data-mp="1ztgdgkc51emp">
                Responsable
              </th>
              <th className="px-4 py-3 text-center text-xs font-semibold text-slate-600 uppercase tracking-wide w-24" data-id="element-5210" data-mp="1pwbrolm7fl6f">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-5211" data-mp="ej99jm4gink5">
            {departements.map(dept => <tr key={dept.id} className="hover:bg-slate-50" data-id="element-5212" data-mp="2h5eka4jd0qo3">
                <td className="px-4 py-3 text-sm text-slate-700 font-medium" data-id="element-5213" data-mp="2h6y5m9jvhrwq">
                  {dept.nom}
                </td>
                <td className="px-4 py-3 text-sm text-slate-600" data-id="element-5214" data-mp="27es9cnml8obq">
                  {dept.responsable}
                </td>
                <td className="px-4 py-3 text-center" data-id="element-5215" data-mp="22exmqw9uikwh">
                  <div className="flex items-center justify-center gap-2" data-id="element-5216" data-mp="1yedp7rld1f9t">
                    <button className="text-slate-400 hover:text-[#4F46E5]" data-id="element-5217" data-mp="1yfotrtmmqr1z">
                      <PencilIcon className="w-4 h-4" data-id="element-5218" data-mp="1tehmrwsb9vwd" />
                    </button>
                    <button className="text-slate-400 hover:text-red-600" data-id="element-5219" data-mp="1oh8zxiw7x3os">
                      <TrashIcon className="w-4 h-4" data-id="element-5220" data-mp="1jhcynrewnqcx" />
                    </button>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
  const renderCategories = () => <div className="space-y-4" data-id="element-5221" data-mp="3dw75thp2bax9">
      <div className="flex items-center justify-between" data-id="element-5222" data-mp="3dvxf1rw70zqi">
        <h3 className="text-lg font-bold text-[#0F172A]" data-id="element-5223" data-mp="3mcxw2dvkdf4s">Catégories</h3>
        <button className="px-4 py-2 text-sm font-medium text-[#4F46E5] border border-[#4F46E5] rounded-lg hover:bg-[#4F46E5] hover:text-white transition-colors flex items-center gap-2" data-id="element-5224" data-mp="3qdhv5mzp6stk">
          <PlusIcon className="w-4 h-4" data-id="element-5225" data-mp="3y5jdfxnm0hm" /> Ajouter une catégorie
        </button>
      </div>
      <div className="bg-white rounded-lg border border-slate-200 overflow-hidden" data-id="element-5226" data-mp="3zzuy3n1cg91">
        <table className="w-full" data-id="element-5227" data-mp="33f3kpt6yqrj8">
          <thead className="bg-slate-50 border-b border-slate-200" data-id="element-5228" data-mp="37em069g0maeo">
            <tr data-id="element-5229" data-mp="37gyk2s5c2uud">
              <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wide" data-id="element-5230" data-mp="3cdyq5326nxlh">
                Nom
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wide" data-id="element-5231" data-mp="3hduskxv8fgyx">
                Département
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wide" data-id="element-5232" data-mp="wmklj1vosobj">
                SLA (Jours)
              </th>
              <th className="px-4 py-3 text-center text-xs font-semibold text-slate-600 uppercase tracking-wide w-24" data-id="element-5233" data-mp="1hr4u6xw9da2x">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-5234" data-mp="1rhzh84hbwdpf">
            {categories.map(cat => {
            const dept = departements.find(d => d.id === cat.departementId);
            return <tr key={cat.id} className="hover:bg-slate-50" data-id="element-5235" data-mp="21djask8f70b0">
                  <td className="px-4 py-3 text-sm text-slate-700 font-medium" data-id="element-5236" data-mp="1wg199ewqfnd1">
                    {cat.nom}
                  </td>
                  <td className="px-4 py-3 text-sm text-slate-600" data-id="element-5237" data-mp="2ae951ji18imm">
                    {dept?.nom}
                  </td>
                  <td className="px-4 py-3 text-sm text-slate-600" data-id="element-5238" data-mp="25h8vgylz4xqr">
                    {cat.sla}
                  </td>
                  <td className="px-4 py-3 text-center" data-id="element-5239" data-mp="g3cfgaet1hk2">
                    <div className="flex items-center justify-center gap-2" data-id="element-5240" data-mp="b3q2m22w23bs">
                      <button className="text-slate-400 hover:text-[#4F46E5]" data-id="element-5241" data-mp="2mpi8wpnuai0v">
                        <PencilIcon className="w-4 h-4" data-id="element-5242" data-mp="2rolecb7qeq9d" />
                      </button>
                      <button className="text-slate-400 hover:text-red-600" data-id="element-5243" data-mp="2dxg9mupib7s6">
                        <TrashIcon className="w-4 h-4" data-id="element-5244" data-mp="2dvdlkg7wzoq3" />
                      </button>
                    </div>
                  </td>
                </tr>;
          })}
          </tbody>
        </table>
      </div>
    </div>;
  const renderStatuts = () => <div className="space-y-4" data-id="element-5245" data-mp="28yn7tzjl157u">
      <div className="flex items-center justify-between" data-id="element-5246" data-mp="28zy9nttgw2wb">
        <h3 className="text-lg font-bold text-[#0F172A]" data-id="element-5247" data-mp="1uz3yj3f1bnty">Statuts</h3>
        <button className="px-4 py-2 text-sm font-medium text-[#4F46E5] border border-[#4F46E5] rounded-lg hover:bg-[#4F46E5] hover:text-white transition-colors flex items-center gap-2" data-id="element-5248" data-mp="1v0yo4v19444d">
          <PlusIcon className="w-4 h-4" data-id="element-5249" data-mp="3paiqlqvipzcv" /> Ajouter un statut
        </button>
      </div>
      <div className="bg-white rounded-lg border border-slate-200 overflow-hidden" data-id="element-5250" data-mp="3tdfffzbnirp9">
        <table className="w-full" data-id="element-5251" data-mp="23pyzcpcsuavm">
          <thead className="bg-slate-50 border-b border-slate-200" data-id="element-5252" data-mp="23oxk08or3283">
            <tr data-id="element-5253" data-mp="28j1s4v9r5gar">
              <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wide" data-id="element-5254" data-mp="28jjxqiib16vc">
                Nom
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wide" data-id="element-5255" data-mp="1yqw57zycxp2f">
                Couleur
              </th>
              <th className="px-4 py-3 text-center text-xs font-semibold text-slate-600 uppercase tracking-wide w-24" data-id="element-5256" data-mp="2mffb68txpprc">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-5257" data-mp="2dimsna4klwpl">
            {statuts.map(statut => <tr key={statut.id} className="hover:bg-slate-50" data-id="element-5258" data-mp="2hgklqo1gp2y9">
                <td className="px-4 py-3 text-sm text-slate-700 font-medium" data-id="element-5259" data-mp="12157lrurrlse">
                  {statut.nom}
                </td>
                <td className="px-4 py-3 text-sm text-slate-600" data-id="element-5260" data-mp="164jpko29qc8h">
                  <div className="flex items-center gap-2" data-id="element-5261" data-mp="yio88u2ylw0o">
                    <div className={`w-4 h-4 rounded-full ${statut.couleur}`} data-id="element-5262" data-mp="ylahcy5i0jl0"></div>
                    <span className="text-xs text-slate-500" data-id="element-5263" data-mp="tmh1x06niii7">
                      {statut.couleur}
                    </span>
                  </div>
                </td>
                <td className="px-4 py-3 text-center" data-id="element-5264" data-mp="13jviczskr7ai">
                  <div className="flex items-center justify-center gap-2" data-id="element-5265" data-mp="fsq2wlqjqh0q">
                    <button className="text-slate-400 hover:text-[#4F46E5]" data-id="element-5266" data-mp="fqvid8j6sqx6">
                      <PencilIcon className="w-4 h-4" data-id="element-5267" data-mp="avg5ojwx112c" />
                    </button>
                    <button className="text-slate-400 hover:text-red-600" data-id="element-5268" data-mp="pjkqbtfj3mnr">
                      <TrashIcon className="w-4 h-4" data-id="element-5269" data-mp="krj8lrzld3qc" />
                    </button>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
  const renderMessages = () => <div className="space-y-6" data-id="element-5270" data-mp="3o7zzjebo2u14">
      <div className="flex items-center justify-between" data-id="element-5271" data-mp="3o6owxhtyjsbl">
        <h3 className="text-lg font-bold text-[#0F172A]" data-id="element-5272" data-mp="hqhqdsq3nyjx">
          Messages automatisés
        </h3>
        <button className="px-4 py-2 text-sm font-medium text-[#4F46E5] border border-[#4F46E5] rounded-lg hover:bg-[#4F46E5] hover:text-white transition-colors flex items-center gap-2" data-id="element-5273" data-mp="lrtgs0gssnt6">
          <PlusIcon className="w-4 h-4" data-id="element-5274" data-mp="vj7dy1la1bj5" /> Nouveau message
        </button>
      </div>

      <div className="space-y-6" data-id="element-5275" data-mp="3uyknuy3kizr4">
        {messages.map((msg, idx) => <div key={msg.id} className="bg-white rounded-xl border border-slate-200 overflow-hidden" data-id="element-5276" data-mp="3v0fconhync0h" data-mpi={idx}>
            <div className="bg-slate-50 px-4 py-3 border-b border-slate-200 flex items-center justify-between" data-id="element-5277" data-mp="2w3cu7pb1hcn">
              <input type="text" value={msg.titre} onChange={e => {
            const updated = [...messages];
            updated[idx].titre = e.target.value;
            setMessages(updated);
          }} className="font-semibold text-slate-700 bg-transparent border-none focus:outline-none focus:ring-0 w-full" data-id="element-5278" data-mp="csg5r3d0zr6c" />
              <button className="text-slate-400 hover:text-red-600 ml-4" data-id="element-5279" data-mp="38q6vvmkcuutf">
                <TrashIcon className="w-4 h-4" data-id="element-5280" data-mp="33qkk7hk6dmmq" />
              </button>
            </div>
            <div className="p-4" data-id="element-5281" data-mp="33snhmmnnqi1h">
              {renderToolbar()}
              <textarea value={msg.contenu} onChange={e => {
            const updated = [...messages];
            updated[idx].contenu = e.target.value;
            setMessages(updated);
          }} rows={4} className="w-full px-3 py-2 border border-slate-200 border-t-0 rounded-b-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5] focus:border-transparent" data-id="element-5282" data-mp="2yyjaa2ahc7zv" />
            </div>
          </div>)}
      </div>
    </div>;
  return <div className="flex gap-6" data-id="element-5283" data-mp="2g2t7wdymx9lg">
      {/* Section Switcher */}
      <div className="w-48 flex-shrink-0" data-id="element-5284" data-mp="2b36sbxvc3h9h">
        <div className="bg-white rounded-xl border border-slate-200 p-2 space-y-1 sticky top-4" data-id="element-5285" data-mp="e9mvk7e8cdgc">
          <button onClick={() => setActiveSection('departements')} className={`w-full px-4 py-3 text-left text-sm font-semibold rounded-lg transition-colors ${activeSection === 'departements' ? 'bg-[#0F172A] text-white' : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'}`} data-id="element-5286" data-mp="9ainxl6yens4">
            Départements
          </button>
          <button onClick={() => setActiveSection('categories')} className={`w-full px-4 py-3 text-left text-sm font-semibold rounded-lg transition-colors ${activeSection === 'categories' ? 'bg-[#0F172A] text-white' : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'}`} data-id="element-5287" data-mp="7dk2uaw1iprl">
            Catégories
          </button>
          <button onClick={() => setActiveSection('statuts')} className={`w-full px-4 py-3 text-left text-sm font-semibold rounded-lg transition-colors ${activeSection === 'statuts' ? 'bg-[#0F172A] text-white' : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'}`} data-id="element-5288" data-mp="3c8iokvxqwqs">
            Statuts
          </button>
          <button onClick={() => setActiveSection('messages')} className={`w-full px-4 py-3 text-left text-sm font-semibold rounded-lg transition-colors ${activeSection === 'messages' ? 'bg-[#0F172A] text-white' : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'}`} data-id="element-5289" data-mp="3brs8tb1b7z1m">
            Messages
          </button>
        </div>
      </div>

      {/* Content Area */}
      <div className="flex-1 bg-white rounded-xl border border-slate-200 p-8" data-id="element-5290" data-mp="365rfjhq7mhxk">
        {activeSection === 'departements' && renderDepartements()}
        {activeSection === 'categories' && renderCategories()}
        {activeSection === 'statuts' && renderStatuts()}
        {activeSection === 'messages' && renderMessages()}
      </div>
    </div>;
}